import { render } from "./customer_services.vue?vue&type=template&id=3b0c0b62&scoped=true"
import script from "./customer_services.vue?vue&type=script&lang=js"
export * from "./customer_services.vue?vue&type=script&lang=js"

import "./customer_services.vue?vue&type=style&index=0&id=3b0c0b62&scoped=true&lang=css"

import exportComponent from "D:\\learning\\isp_digital\\Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b0c0b62"]])

export default __exports__